module.exports = __webpack_public_path__ + "img/integration.7f433d24.svg";